import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { Calendar } from "primereact/calendar";

import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import { format } from "date-fns";
import storage from "../../Services/Storage";
import Axios from "../../api/Axios";
import { toast } from "react-toastify";

const PurchaseOrderGeneration = () => {
    const [dateChange, setDatechnage] = useState(null);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");
    let purchs_URL = "StockNorm/GetStockNormExcelData?";
    const exportdata = async () => {
        // console.log("hello");
        setLoadingExcel(true);
        // format(date, "dd/MM/yyyy")
        try {
            let datechange = format(new Date(dateChange),"dd/MM/yyyy");
            const exp_api = `${purchs_URL}CompId=${auth.CompId}&strOrddate=${datechange}`;
            const exp_res = await Axios.get(exp_api);
            if (exp_res.data.Data.length == 0) {
                toast.warn("No data found.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
            } else {
                downloadExcel(
                    exp_res.data.Data,
                    `Purchase_order${GetDateFormat()}.xlsx`
                );
            }
            setLoadingExcel(false);
        } catch (error) {
            console.log(error);
            setLoadingExcel(false);
        }
    };
    // console.log(dateChange);
    return (
        <>
            <div className="col-12 pt-3 pb-5">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Purchase Order Generation</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block">
                                <label className="form-label">Order Date </label>
                                <Calendar
                                    value={dateChange}
                                    onChange={(e) => setDatechnage(e.value)}
                                    dateFormat="dd-MM-yy"
                                    showIcon
                                />
                            </div>
                        </div>
                        {/* <div className="col-lg-5 col-md-5 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">To Date</label>
                                <Calendar  showIcon  />
                            </div>
                        </div> */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end">
                                <button
                                    type="submit"
                                    title="Download"
                                    className="btn btn-primary"
                                    disabled={loadingExcel||dateChange==null}
                                    onClick={exportdata}
                                >
                                    {loadingExcel ? "Loading..." : "Download"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PurchaseOrderGeneration;
